import React from 'react';
import PropTypes from 'prop-types';

const CheckBox = ({ index, updateChecked, checked }) => (
  <React.Fragment>
    <div className="book book_tb">
      <input
        type="checkbox"
        name="tick"
        className="checkdiv"
        id={`em_${index}`}
        checked={checked !== undefined ? checked : false}
        onClick={e => updateChecked(index, e.target.checked)}
      />
      <label htmlFor={`em_${index}`}>
        <span className="bookbox" />
      </label>
    </div>
  </React.Fragment>
);

CheckBox.propTypes = {
  index: PropTypes.number.isRequired,
  updateChecked: PropTypes.func,
};

export default CheckBox;



// WEBPACK FOOTER //
// ./src/components/checkBox/CheckBox.jsx